import { EditButton, EmailField, List, ShowButton, useTable } from '@refinedev/antd';
import { BaseRecord } from '@refinedev/core';
import { Space } from 'antd';

import AppTable from '@/components/general/AppTable';
import LinkTextField from '@/components/general/LinkTextField';
import ProtectedCreateButton from '@/components/protected/ProtectedCreateButton';
import { usePermissionContext } from '@/contexts/PermissionContext';
import { useUserContext } from '@/contexts/UserContext';
import { Shipper } from '@/model/Logistic/Shipper/Shipper';

const ShippersList = () => {
  const { hasPermission } = usePermissionContext();
  const { pageSizePreference } = useUserContext();
  const { tableProps } = useTable<Shipper>({
    syncWithLocation: true,
    queryOptions: {
      refetchInterval: 300000, // 5 minutes
    },
    pagination: {
      pageSize: pageSizePreference,
    },
  });

  return (
    <List
      headerButtons={({ createButtonProps }) => (
        <>
          <ProtectedCreateButton {...createButtonProps} />
        </>
      )}>
      <AppTable {...tableProps} rowKey="id" scroll={{ x: 1000, y: 'calc(100dvh - 310px)' }}>
        <AppTable.Column
          dataIndex="id"
          title={'Id'}
          width={50}
          render={value =>
            hasPermission('show') ? (
              <LinkTextField label={value} to={`/shippers/show/${value}`} local withoutColor />
            ) : (
              value
            )
          }
        />
        <AppTable.Column dataIndex="name" title={'Nombre'} />
        <AppTable.Column dataIndex="address" title={'Dirección'} />
        <AppTable.Column dataIndex="phone" title={'Teléfono'} width={150} />
        <AppTable.Column dataIndex="phone2" title={'Teléfono 2'} width={150} />
        <AppTable.Column
          dataIndex={'email'}
          title={'Email'}
          width={250}
          render={(value: any) => <EmailField value={value} />}
        />
        {(hasPermission('edit') || hasPermission('show')) && (
          <AppTable.Column
            dataIndex="actions"
            width={55}
            fixed="right"
            render={(_, record: BaseRecord) => (
              <Space>
                {hasPermission('edit') ? (
                  <EditButton hideText size="small" recordItemId={record.id} />
                ) : (
                  <ShowButton hideText size="small" recordItemId={record.id} />
                )}
              </Space>
            )}
          />
        )}
      </AppTable>
    </List>
  );
};

export default ShippersList;
